import { httpCreate } from './http';

const http = httpCreate('/srv/information-card');

export const informationCard = {
	//添加信息卡片
	addInfoCard(gatherId, data) {
		console.log(data);
		return http.post(`/${gatherId}`, data);
	},
	//修改
	updateInfoCard(id, data) {
		return http.put(`/${id}`, data);
	},
	//删除
	deleteCard(id) {
		return http.delete(`/${id}`);
	},
	// 获取列表
	getInfoCard(id) {
		return http.get(`/list/${id}`);
	},
	// 排序
	updatePriority(data) {
		return http.post('/updatePriority', data);
	},
};
